<template>
  <div class="auth-wrapper auth-v2 email-verified-page">
    <b-row class="auth-inner m-0">
      <b-col
        lg="7"
        class="d-none d-lg-flex align-items-center p-5"
      >
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
          <b-img
            fluid
            :src="sideImg"
            alt="Email verified"
            class="verified-illustration"
          />
        </div>
      </b-col>

      <b-col
        lg="5"
        class="d-flex align-items-center auth-bg px-2 p-lg-5"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto text-center"
        >
          <div class="mb-2">
            <b-img
              width="120"
              fluid
              src="/logo.png"
              alt="My PODA"
            />
          </div>

          <div class="verified-badge mx-auto mb-2">
            <feather-icon
              icon="CheckCircleIcon"
              size="48"
            />
          </div>

          <b-card-title
            title-tag="h2"
            class="mb-1 font-weight-bold"
          >
            Email Verified
          </b-card-title>
          <b-card-text class="mb-2">
            Your email has been verified successfully. You can now sign in to your vendor account.
          </b-card-text>

          <b-button
            block
            variant="primary"
            class="verified-login-btn"
            :to="{ name: 'auth-login' }"
          >
            Continue to Login
          </b-button>
        </b-col>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BButton,
  BImg,
  BCardTitle,
  BCardText,
} from 'bootstrap-vue'

export default {
  components: {
    BRow,
    BCol,
    BButton,
    BImg,
    BCardTitle,
    BCardText,
  },
  data() {
    return {
      sideImg: require('@/assets/images/pages/login-v2.svg'),
    }
  },
}
</script>

<style scoped lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';

.email-verified-page {
  .verified-badge {
    width: 88px;
    height: 88px;
    border-radius: 50%;
    background: rgba(40, 199, 111, 0.12);
    color: #28c76f;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .verified-login-btn {
    background: #7367f0 !important;
    border-color: #7367f0 !important;
    margin-top: 0.5rem;
  }

  .verified-illustration {
    max-width: 520px;
  }
}
</style>
